import { defineComponent } from "vue";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography"
import Button from "@/components/general/Button"

export default defineComponent({
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Button,
  },
  methods: {
    redirect() {
      alert("Redirigiendo")
    }
  }
});
